module.exports = __webpack_public_path__ + "static/media/personalized-feedback-bg.9f7a1dc4.jpg";